export const views = {
  savedSearches: 'savedSearches',
  followedResearchers: 'followedResearchers',
  followedOrganisations: 'followedOrganisations',
};

export const metricActions = {
  [views.savedSearches]: 'VisitAlertsTab',
  [views.followedResearchers]: 'VisitFollowedResearchersTab',
  [views.followedOrganisations]: 'VisitFollowedOrganisationsTab',
};

export const filterTypes = {
  savedSearch: 0,
  alert: 1,
};

export const missingPurchasingAlertLicenseTooltip =
  'This user cannot receive purchasing alerts due to license restrictions.';
